<template>
  <div v-if="show" class="mdl-overlay" @click.self="$emit('close')">
    <div class="mdl-card shadow-lg border-0 rounded-4 p-4 modal-parent-message" style="max-width: 520px; width: 90%;">
      <div class="d-flex align-items-center justify-content-between pb-3 mb-3 modal-header-border">
        <div class="d-flex align-items-center gap-3">
          <div class="topup-icon-badge parent-msg-icon-badge">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>
          <div>
            <h4 class="mb-0 fw-bold modal-title-text">Üzenet a gondviselőnek</h4>
            <p class="modal-subtitle-text small mb-0">Címzett: {{ parentEmail }}</p>
          </div>
        </div>
        <button class="btn btn-sm modal-close-btn rounded-circle" @click="$emit('close')" style="width: 32px; height: 32px; padding: 0;">✕</button>
      </div>

      <form @submit.prevent="onSubmit">
        <div class="mb-3">
          <label class="form-label small fw-semibold modal-label-text mb-1">Tárgy (opcionális)</label>
          <input
            type="text"
            v-model="subject"
            class="form-control modal-input-field"
            placeholder="Pl.: Edzés időpont / Befizetés egyeztetés"
            :disabled="isSending"
          />
        </div>

        <div class="mb-3">
          <label class="form-label small fw-semibold modal-label-text mb-1">Üzenet szövege <span class="text-danger">*</span></label>
          <textarea
            v-model="body"
            rows="5"
            class="form-control modal-input-field"
            placeholder="Írd ide az üzeneted a szülődnek..."
            required
            :disabled="isSending"
          ></textarea>
        </div>

        <div v-if="feedback" class="p-2.5 rounded-3 small mb-3 fw-semibold" :class="success ? 'feedback-success' : 'feedback-error'">
          {{ feedback }}
        </div>

        <div class="d-flex justify-content-end gap-2 pt-2 modal-footer-border">
          <button
            type="button"
            class="btn modal-cancel-btn btn-sm px-3 rounded-3"
            @click="$emit('close')"
            :disabled="isSending"
          >
            Mégse
          </button>
          <button
            type="submit"
            class="modern-btn modern-btn--primary btn-sm px-4 rounded-3"
            :disabled="isSending || !body.trim()"
          >
            <span v-if="isSending">Küldés...</span>
            <span v-else>✉️ Üzenet elküldése</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChildParentMessageModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    parentEmail: {
      type: String,
      default: ''
    },
    isSending: {
      type: Boolean,
      default: false
    },
    feedback: {
      type: String,
      default: ''
    },
    success: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'send'],
  data() {
    return {
      subject: '',
      body: ''
    };
  },
  methods: {
    onSubmit() {
      if (!this.body.trim()) return;
      this.$emit('send', {
        subject: this.subject,
        body: this.body
      });
    },
    reset() {
      this.subject = '';
      this.body = '';
    }
  }
};
</script>

<style scoped>
.mdl-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 1.5rem 1rem;
  z-index: 99999;
}

.mdl-card {
  background: var(--card-bg) !important;
  color: var(--color-text) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.45), 0 10px 15px -5px rgba(0, 0, 0, 0.3) !important;
  position: relative;
  overflow: hidden;
  margin: auto;
  max-height: calc(100vh - 3rem);
}

.modal-header-border {
  border-bottom: 1px solid var(--color-border);
}

.modal-footer-border {
  border-top: 1px solid var(--color-border);
}

.topup-icon-badge {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary-blue, #2563eb), var(--secondary-blue, #0ea5e9));
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.parent-msg-icon-badge {
  background: rgba(37, 99, 235, 0.12) !important;
  color: var(--primary-blue, #2563eb) !important;
}

.modal-title-text {
  color: var(--color-heading);
}

.modal-subtitle-text {
  color: var(--color-text-muted);
}

.modal-label-text {
  color: var(--color-heading);
}

.modal-close-btn {
  background: var(--color-background-soft);
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
}

.modal-cancel-btn {
  background: transparent;
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
}

.modal-input-field {
  background-color: var(--card-bg);
  color: var(--color-text);
  border: 1.5px solid var(--color-border);
}

.feedback-success {
  background-color: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.feedback-error {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

[data-theme="dark"] .modal-parent-message {
  background: #1e293b !important;
  color: #f1f5f9 !important;
  border-color: #334155 !important;
}

[data-theme="dark"] .modal-header-border {
  border-bottom-color: #334155 !important;
}

[data-theme="dark"] .modal-footer-border {
  border-top-color: #334155 !important;
}

[data-theme="dark"] .modal-title-text {
  color: #f8fafc !important;
}

[data-theme="dark"] .modal-subtitle-text {
  color: #94a3b8 !important;
}

[data-theme="dark"] .modal-label-text {
  color: #cbd5e1 !important;
}

[data-theme="dark"] .modal-input-field {
  background-color: #0f172a !important;
  color: #f8fafc !important;
  border-color: #334155 !important;
}

[data-theme="dark"] .modal-close-btn {
  background-color: #334155 !important;
  color: #cbd5e1 !important;
  border-color: #475569 !important;
}

[data-theme="dark"] .modal-cancel-btn {
  background-color: transparent !important;
  color: #cbd5e1 !important;
  border-color: #475569 !important;
}

[data-theme="dark"] .parent-msg-icon-badge {
  background: rgba(37, 99, 235, 0.25) !important;
  color: #93c5fd !important;
}

[data-theme="dark"] .feedback-success {
  background-color: rgba(22, 101, 52, 0.25) !important;
  color: #86efac !important;
  border-color: rgba(34, 197, 94, 0.4) !important;
}

[data-theme="dark"] .feedback-error {
  background-color: rgba(153, 27, 27, 0.25) !important;
  color: #fca5a5 !important;
  border-color: rgba(239, 68, 68, 0.4) !important;
}
</style>
